import { RadioButtonOption } from "../../../common/enums";
import Signature from "../../Signature";

export const HEAVY_LIFTING_CHECKLIST_VERSION_2026_02 = 1;

export type HeavyLiftingChecklist = {
    checklistVersion: number | undefined;
    isInfraContacted: RadioButtonOption;
    isApprovedByInfra: RadioButtonOption;
    ifApprovedByInfraName: string;
    ifApprovedByInfraNumber: string;
    hasInfraDoneExposuresOnQuay: RadioButtonOption;
    isLiftLineInGoodCondition: RadioButtonOption;
    isLiftLineCorrectForTheWeight: RadioButtonOption;
    isCrainOperatorEducated: RadioButtonOption;
    isEquipmentTested: RadioButtonOption;
    isLiftAreaShutOff: string;
    isWorkDoneBeneathLoad: RadioButtonOption;
    isLiftingHookOpen: RadioButtonOption;
    isSupportLegsCorrect: RadioButtonOption;
    isGroundGotBearingCapcity: RadioButtonOption;
    isLiftPlanInPlace: RadioButtonOption;
    isRiskanalysDone: RadioButtonOption;
    isSignalmanChoosen: RadioButtonOption;
    isControlLineAvailable: RadioButtonOption;
    isVehicleAroundRorgatan: RadioButtonOption;
    isInfrastructureDepartmentContacted: RadioButtonOption;
    isOpenLiftingHookUsed: RadioButtonOption;
    isLiftAreaShutOff_Cones: boolean;
    isLiftAreaShutOff_Tape: boolean;
    isLiftAreaShutOff_NA: boolean;

    craneOperatorSignature: Signature;
};
